<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Empleados</h4>
            <div class="small text-muted">Administración del legajo de cada empleado</div>
          </b-col>

          <b-col sm="5">
            <b-button @click="add()" 
                      type="button" 
                      variant="primary" 
                      size="sm" 
                      class="btn-pill float-right ml-2" 
                      v-b-tooltip.hover title="Agregar Empleado"
                      v-if="access.elements.actionCrud">
              <i class="fa fa-plus"></i> Agregar
            </b-button>

            <b-col sm="12" class="d-none d-md-block" v-if="!table.mostrarFiltros">
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" @click="table.mostrarFiltros=true" v-b-tooltip.hover title="Mostrar filtros">
                <i class="fa fa-filter"></i> Mostrar Filtros
              </b-button>
            </b-col>
            <b-col sm="12" class="d-none d-md-block" v-else>
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" v-if="table.mostrarFiltros" @click="table.mostrarFiltros=false" v-b-tooltip.hover title="Ocultar filtros">
                <i class="fa fa-window-close"></i>
              </b-button>
            </b-col>
          </b-col>             
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row v-if="table.mostrarFiltros">
          <b-col sm="4">
            <b-form-group>
              <b-input-group>
                <b-form-input type="text" size="sm" placeholder="Ingrese su busqueda" v-model="table.filter"></b-form-input>
                <b-input-group-prepend>
                  <b-button variant="dark" size="sm" :disabled="!table.filter" @click="table.filter = ''">
                    <i class="fa fa-filter"></i> Filtrar
                  </b-button>
                </b-input-group-prepend>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-table class="mb-0"
                    responsive="sm"
                    head-variant="dark"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"
                    :filter="table.filter"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    v-if="table.items.length">

                <template v-slot:cell(id)="data">
                  <b>{{ data.item.id }}</b>
                </template>

                <template v-slot:cell(image)="data">
                  <b-avatar :src="data.item.staff.image"
                            v-if="data.item.staff.image">
                  </b-avatar>
                  <b-avatar v-else                  
                            variant="dark">
                  </b-avatar>                                  
                </template>

                <template v-slot:cell(way_working)="data">
                  <div v-if="data.item.way_working=='hours'">
                    <b>{{ data.item.hours }} Hs.</b> Diarias
                  </div>
                  <div v-if="data.item.way_working=='projects'">
                    <b>Por Proyecto</b>
                  </div>
                  <div v-if="data.item.way_working=='account'">
                    <b>Por Cuenta</b>
                  </div>                                    
                </template>

                <template v-slot:cell(salary)="data">
                  <div v-if="access.elements.showSalary">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(data.item.salary)}}                  
                  </div>
                  <div v-else>
                    -
                  </div>                  
                </template>      

                <template v-slot:cell(category_id)="data">
                  <b>{{ data.item.category.id }}</b> - {{data.item.category.name}}
                </template>                

                <template v-slot:cell(active)="data">
                  <div v-if="data.item.active">
                    <b-badge variant="success">Activo</b-badge>                    
                  </div>
                  <div v-else>
                    <b-badge variant="danger">Inactivo</b-badge>                    
                  </div>
                </template>

                <template v-slot:cell(permission_admin_projects)="data">
                  <div v-if="data.item.permission_admin_projects">
                    <b-badge variant="warning">SI</b-badge>                    
                  </div>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right">
                    <b-dropdown-item @click="irDetailHours(data.item)">
                      <b-icon icon="clock-history"></b-icon> Horarios
                    </b-dropdown-item>                          
                    <b-dropdown-header v-if="access.elements.actionCrud">
                      Acciones
                    </b-dropdown-header>                    
                    <b-dropdown-item @click="edit(data.item)" v-if="access.elements.actionCrud">
                      <i class="fa fa-pencil ml-0 mr-0" style="color:blue"></i> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)" v-if="access.elements.actionCrud">
                      <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>                        
          </b-col>

          <b-col>
            <nav>
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="getRowCount(table.items)"
                            :per-page="table.perPage"
                            v-model="table.currentPage" />
            </nav>
          </b-col> 
        </b-row>
      </b-card>
      

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              header-bg-variant="dark"
              header-text-variant="white">
        <div slot="modal-header">
          {{this.modal.form.title}}
        </div>

        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
          <b-tab title="General" active>
            <b-row>
              <b-col md="12">
                <b-form-checkbox v-model="crud.form.active" 
                                  switch 
                                  size="sm" 
                                  class="mt-4 pull-right">
                  Activo
                </b-form-checkbox>            
              </b-col>     
                        
              <b-col md="12">
                <FindObject type="staff" 
                            @select-object="loadStaff($event)" 
                            :valueID="crud.form.staff_id"/>
              </b-col>

              <b-col md="12">
                <b-form-group label="Nombre">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.name"
                                required
                                placeholder="Ingresar un nombre">
                  </b-form-input>
                </b-form-group>
              </b-col>       

              <b-col md="12">
                <b-form-group label="Teléfono">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.phone"
                                required
                                placeholder="Cod país [sin el signo] + nueve [9] + cod área [sin el 0] + nro cel [sin el 15] (total 13 dígitos)">
                  </b-form-input>
                </b-form-group>
              </b-col> 

              <b-col md="12">
                <b-form-group label="Email">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.email"
                                required
                                placeholder="Ingresar un email">
                  </b-form-input>
                </b-form-group>
              </b-col> 
            </b-row>
          </b-tab>
          <b-tab title="Arreglo Comercial">
            <b-row>
              <b-col md="12">
                <FindObject type="employeeCategory" 
                            @select-object="loadEmployeeCategory($event)" :valueID=
                            "crud.form.category_id"/>
              </b-col>                                                    

              <b-col md="12">
                <b-form-group label="Formas de Contratación"
                              description="El precio es aplicado según la forma de contratación.">
                  <b-form-select v-model="crud.form.way_working" 
                                :options="arr.select.way_working"
                                stacked
                                @input="changeWayWorking()">
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="4" v-if="crud.form.way_working=='hours'">
                <b-form-group label="Horas Diarias">
                  <b-form-input type="number"
                                size="sm"
                                v-model="crud.form.hours"                            
                                placeholder="Ingresar las horas diarias de trabajo">
                  </b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="8">
                <b-form-group label="Salario" :description="alerts.salary_input">
                  <b-form-input type="number"
                                size="sm"
                                step="0.01"
                                v-model="crud.form.salary"                            
                                placeholder="Ingresar el sueldo mensual">
                  </b-form-input>
                </b-form-group>
              </b-col>          
            </b-row>
          </b-tab>
          <b-tab title="Permisos">
            <b-row>
              <b-col md="12">
                <b-form-checkbox v-model="crud.form.permission_admin_projects" 
                                  switch 
                                  size="sm" 
                                  class="mt-4 pull-right">
                  Permite visualizar todos los proyectos como un perfil Administrador
                </b-form-checkbox>            
              </b-col>               
            </b-row>
          </b-tab>
        </b-tabs>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()">Guardar</b-button>          
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject' 

  export default {
    components: {
      FindObject
    },    
    data: () => {
      return {      
        access: {
          module_id: Modules.EMPLEADOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudEmployee',
          elements: {
            actionCrud: true,
            showSalary: true,            
          }
        }, 
        table : {
          items: [],
          fields: [
            {key: 'id', label: 'ID', sortable: true, class:"align-middle"},
            {key: 'image', label: 'Perfil', class:"align-middle text-center "},
            {key: 'name', label: 'Nombre', class:"align-middle"},    
            {key: 'phone', label: 'Teléfono', class:"align-middle"},            
            {key: 'email', label: 'Email', class:"align-middle"},                       
            {key: 'category_id', label: 'Categoria', class:"align-middle text-center "},
            {key: 'way_working', label: 'Forma Contratación', class:"align-middle text-center"},
            {key: 'salary', label: 'Salario', class:"align-middle text-center"},            
            {key: 'active', label: 'Estado', class:"align-middle text-center "},
            {key: 'permission_admin_projects', label: 'Admin Proyectos', class:"align-middle text-center "},
            {key: 'f_action', label:'', class:"align-middle text-center "},
          ],
          filter: null,
          mostrarFiltros: false,
          currentPage: 1,
          perPage: 50,
        },
        crud: {
          form: {
            id: 0,
            name: '',
            phone: '',
            email: '',            
            staff: null,
            staff_id: 0,
            category: null,
            category_id: 0,
            hours: 0,
            salary: 0,            
            active: true,   
            way_working: 'hours',
            permission_admin_projects: false,
          },          
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
        },
        arr: {          
          select: {
            way_working: [              
              { value: 'hours', text: 'Por Horas Diarias' },         
              { value: 'projects', text: 'Por Proyectos' },                                 
              { value: 'account', text: 'Por Cuentas' },   
            ],
          }
        },
        alerts: {
          salary_input: 'El salario corresponde al mes completo.'
        }                        
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      this.access.elements.actionCrud = Helper.hasAccessElement(this.access, 'action_crud')
      this.access.elements.showSalary = Helper.hasAccessElement(this.access, 'show_salary')      
      /* Fin configuracion */
    }, 
    mounted() {
      this.load()
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      load() {
        var result = serviceAPI.obtenerEmpleado()

        result.then((response) => {
          var data = response.data
          this.table.items = data
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });        
      },
      loadEmployeeCategory (object) {
        if(object){
          this.crud.form.category = object
          this.crud.form.category_id = object.id
        } else {
          this.crud.form.category = null
          this.crud.form.category_id = 0
        }
      },      
      loadStaff (object) {
        if(object){
          if(this.crud.form.staff_id != object.id) {
            this.crud.form.staff = object
            this.crud.form.staff_id = object.id
            this.crud.form.name = object.name
            this.crud.form.phone = object.phone
            this.crud.form.email = object.email            
          }
        } else {
          this.crud.form.staff = null
          this.crud.form.staff_id = 0
          this.crud.form.name = ''
          this.crud.form.phone = ''
          this.crud.form.email = ''           
        }
      },            
      add() {
        this.crud.form.id = 0
        this.crud.form.name = ''    
        this.crud.form.staff_id = 0
        this.crud.form.staff = null
        this.crud.form.category_id = 0
        this.crud.form.category = null
        this.crud.form.phone = ''
        this.crud.form.email = ''
        this.crud.form.hours = 0 
        this.crud.form.salary = 0         
        this.crud.form.active = true
        this.crud.form.way_working = 'hours'
        this.crud.form.permission_admin_projects = false

        this.modal.form.title = "Nuevo Empleado"
        this.modal.form.active = true
      },
      edit(item) {        
        this.crud.form.id = item.id
        this.crud.form.name = item.name   
        this.crud.form.staff_id = item.staff.id   
        this.crud.form.staff = item.staff   
        this.crud.form.category_id = item.category.id   
        this.crud.form.category = item.category
        this.crud.form.phone = item.phone
        this.crud.form.email = item.email
        this.crud.form.hours = item.hours
        this.crud.form.salary = item.salary             
        this.crud.form.active = item.active
        this.crud.form.way_working = item.way_working
        this.crud.form.permission_admin_projects = item.permission_admin_projects

        this.modal.form.title = "Editar Empleado"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name        

        this.$bvModal.msgBoxConfirm('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Empleado',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarEmpleado(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        // valida que tenga el formato correcto para emails
        if(this.crud.form.email) {
          var expreg = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$")
          if (!expreg.test(this.crud.form.email)) {          
            this.$awn.alert("El email no posee un formato válido")          
            return false
          }       
        }

        // valida que tenga el formato para whatsapp
        if(this.crud.form.phone) {
          if(this.crud.form.phone.length < 9 || this.crud.form.phone.length > 20) {
            this.$awn.alert("El nro de télefono no posee un formato válido")
            return false
          }
        }

        let loader = this.$loading.show();
        if (this.crud.form.id) {
          var result = serviceAPI.editarEmpleado(this.crud.form);
        } else {
          var result = serviceAPI.agregarEmpleado(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      changeWayWorking() {        
        if(this.crud.form.way_working == 'hours') {
          this.alerts.salary_input = 'El salario corresponde al mes completo.'
          this.crud.form.hours = 0
        }

        if(this.crud.form.way_working == 'projects') {
          this.alerts.salary_input = 'El salario corresponde a lo cobrado por proyecto.'
          this.crud.form.hours = 0
        }

        if(this.crud.form.way_working == 'account') {
          this.alerts.salary_input = 'El salario corresponde a lo cobrado por cada cuenta.'
          this.crud.form.hours = 0
        }        
      },
      irDetailHours(data) {        
        this.$router.push({ name: 'EmployeeStaffDetailHours', params: { employeeID: data.id } })                  
      }      
    }     
  }
</script>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;    
  }  
</style>